import { render, staticRenderFns } from "./AdGroupShuttle.vue?vue&type=template&id=4fe94e35&scoped=true"
import script from "./AdGroupShuttle.vue?vue&type=script&lang=js"
export * from "./AdGroupShuttle.vue?vue&type=script&lang=js"
import style0 from "./AdGroupShuttle.vue?vue&type=style&index=0&id=4fe94e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe94e35",
  null
  
)

export default component.exports